import React, { useState } from 'react';
import { getElementId, useWebformElement } from '../utils';

import WebformElementWrapper from './webformElementWrapper';
import { Box, Flex, Text } from 'rebass';
import { Input } from "@rebass/forms";
import theme, { placeholderStyles } from "../../../gatsby-plugin-theme-ui";
import { pathOr } from "ramda";
import { transparentize } from "@theme-ui/color";

const DEFAULT_PLACEHOLDER = '';

export const WebformFile = ({ element, error, color, columns }) => {
	const id = getElementId(element.name);
	const [fileName, setFileName] = useState(DEFAULT_PLACEHOLDER);
	const [inputProps, settings] = useWebformElement(element, {
		className: 'form-control',
		name: element.name,
		type: element.type,
		id
	});

	if (element.type === 'hidden') {
		return <input {...inputProps} />
	}

	const extensions = pathOr(null, ['attributes', 'file_extensions'], settings);
	const placeholder = pathOr(null, ['attributes', 'file_placeholder'], settings);

	return (
		<WebformElementWrapper settings={settings} error={error} labelFor={id} color={color} columns={columns}>
			<Box sx={{ position: 'relative', width: '100%', height: '100%' }} >
				<Input {...inputProps} onChange={(e) => {
					const files = pathOr([], ['target', 'files'], e);
					if (!files.length) {
						setFileName(DEFAULT_PLACEHOLDER);
					} else {
						setFileName(pathOr('Selected', [0, 'name'], files).substring(0, 7) + '...');
					}
				}} type="file" sx={{ opacity: 0, position: 'relative', zIndex: 3 }} />
				<Flex
					className="input"
					p={2}
					alignItems="center"
					justifyContent="space-between"
					sx={{ position: 'absolute', zIndex: 1, left: 0, top: 0, width: '100%', height: '100%', border: '1px solid', ...theme.forms.input }}
				>
					{fileName || ((placeholder || extensions) ? (
						<Text
							fontSize={1}
							sx={{ ...placeholderStyles, color: transparentize(color, 0.5) }}
							dangerouslySetInnerHTML={{ __html: placeholder || extensions}}
						/>) : null)}
				</Flex>
			</Box>
		</WebformElementWrapper>
	)
};

export default WebformFile;
